import React from "react";
import MainSkeleton from "./MainSkeleton";

const SidebarSkeleton = ({ bgPr }) => {
  return (
    <aside className="flex flex-col gap-8 md:gap-12 lg:gap-16">
      <div
        className={`${
          bgPr ? "bg-prColor" : "bg-scColor"
        } flex-grow  px-4 xs:px-8 py-8 xs:py-12 shadow shadow-borderColor w-full lg:w-[16rem]`}
      >
        <MainSkeleton classes={"w-[12rem] h-[2rem] sm:h-[2.5rem]"} />
        <div className="flex flex-col md:flex-row lg:flex-col gap-6">
        <div
          className={`mt-6 w-full ${bgPr ? "bg-scColor" : "bg-prColor"} p-8`}
        >
          <MainSkeleton classes={"mt-6 w-full h-[1.8rem]"} />
          <MainSkeleton classes={"mt-6 w-full h-[1.8rem]"} />
        </div>
        <div
          className={`mt-6 w-full ${bgPr ? "bg-scColor" : "bg-prColor"} p-8`}
        >
          <MainSkeleton classes={"mt-6 w-full h-[1.8rem]"} />
          <MainSkeleton classes={"mt-6 w-full h-[1.8rem]"} />
        </div>
        </div>
       
      </div>
      <div
        className={`${
          bgPr ? "bg-prColor" : "bg-scColor"
        } flex-grow  px-4 xs:px-8 py-8 xs:py-12 shadow shadow-borderColor w-full lg:w-[16rem]`}
      >
        <MainSkeleton classes={"w-[12rem] h-[2rem] sm:h-[2.5rem]"} />
        <div className="flex gap-3 mt-4">
          <MainSkeleton classes={" w-10 h-10"} />
          <MainSkeleton classes={" w-10 h-10"} />
        </div>
      </div>
    </aside>
  );
};

export default SidebarSkeleton;
